export enum BuildingMeasuresOverviewObjective {
  CostReduction = 'costReduction',
  Co2Reduction = 'co2Reduction',
  ImproveEnergyLabel = 'improveEnergyLabel',
  ComplyLawRegulations = 'complyLawRegulations',
  ImplementationOrder = 'implementationOrder'
}
